<template>
  <div class="properties-panel bg-gray-800 dark:bg-gray-900 text-white p-1 border-l border-gray-700 overflow-y-auto">
    <h2 class="elements-label">Propriétés<br/><i>{{ getCurrentCompositionElement ? getCurrentCompositionElement.Name : "..." }}</i></h2>
    <component :isComposition="true" v-if="getCurrentCompositionElement" is="objectInput" :property="null" :element="getCurrentCompositionElement" :container="null"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { defineAsyncComponent } from 'vue';
import * as namespaceStore from "../../vuexStore/namespaceStore.js"
import * as actions from "../../vuexStore/actions.js"
import pageElements from "../../vuexStore/type/definition/pageElement.js"

export default {
  name: 'PropertiesPanel',
  props: {
  },
  components: {
    'colorInput': defineAsyncComponent(() => import('@/components/PropertyComponents/color.vue')),
    'numberInput': defineAsyncComponent(() => import('@/components/PropertyComponents/number.vue')),
    'booleanInput': defineAsyncComponent(() => import('@/components/PropertyComponents/boolean.vue')),
    'selectInput': defineAsyncComponent(() => import('@/components/PropertyComponents/select.vue')),
    'textInput': defineAsyncComponent(() => import('@/components/PropertyComponents/text.vue')),
    'pathInput': defineAsyncComponent(() => import('@/components/PropertyComponents/path.vue')),
    'arrayInput': defineAsyncComponent(() => import('@/components/PropertyComponents/array.vue')),
    'objectInput': defineAsyncComponent(() => import('@/components/PropertyComponents/object.vue')),
  },
  data() {
    return {
      showDeleteConfirm: false,
      showAddSubElementPopup: false
    }
  },
  emits: [
  ],
  computed: {
    ...mapGetters(namespaceStore.THEME, [
      'getCurrentCompositionElement'
    ]),
    canAddSubElement() {
      return pageElements.some((el) => {
        if (!this.getCurrentCompositionElement) return false;
        if (el.type === this.getCurrentCompositionElement.objectType) {
          return el.subType.some(subType => {
            if (subType.is == "array") return true;
            if (this.getCurrentCompositionElement[subType.property] == null)
              return true;
          });
        }
        return false;
      });
    }
  },
  methods: {
    ...mapActions(namespaceStore.THEME, {
      actionRemoveElement: actions.REMOVE_PAGE_ELEMENT,
      addElement: actions.ADD_ELEMENT
    }),
    getSubElement() {
      let elementsToadd = [];
      if (!this.getCurrentCompositionElement) return elementsToadd;
      for (const el of pageElements) {
        if (el.type === this.getCurrentCompositionElement.objectType) {
          pageElements.forEach(element => {
            const find = el.subType.find(subType => {
              if (element.type.match(subType.type)) {
                if (subType.is == "array")
                  return true;
                else if (this.getCurrentCompositionElement[subType.property] == null)
                  return true;
              }
              return false;
            })
            if (find) {
              elementsToadd.push(element);
            }
          });
          return elementsToadd;
        }
      }
      return elementsToadd;
    },
    removeElement() {
      this.actionRemoveElement(this.getCurrentCompositionElement.previewId);
    },
    confirmDelete() {
      this.removeElement();
      this.showDeleteConfirm = false;
    },
    addSubElement(element) {
      this.addElement({
        target: element.property,
        element: element.constructor.fromObject({parent: this.getCurrentCompositionElement}),
        previewId: this.getCurrentCompositionElement.previewId
      });
      this.showAddSubElementPopup = false;
    }
  }
}
</script>

<style scoped>
.elements-label {
  color: #fff;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  text-align: center;
}

.properties-panel {
  width: 100%;
  height: 100%;
}

.property-section {
  @apply bg-gray-700/50 rounded-lg p-4;
}

input[type="color"] {
  @apply cursor-pointer;
  -webkit-appearance: none;
}

input[type="color"]::-webkit-color-swatch-wrapper {
  @apply p-0;
}

input[type="color"]::-webkit-color-swatch {
  @apply border-none rounded;
}

.element-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem;
  background-color: rgba(255, 255, 255, 0.05);
  border-radius: 0.375rem;
  margin-bottom: 1rem;
}

.property-label {
  font-size: 1rem;
  font-weight: 600;
  color: #e5e7eb;
}

.delete-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.375rem;
  background-color: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #ef4444;
  transition: all 0.2s ease;
  padding: 0;
}

.delete-button:hover {
  background-color: rgba(239, 68, 68, 0.3);
  border-color: #ef4444;
}

.delete-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.4);
}

.delete-icon {
  width: 1.25rem;
  height: 1.25rem;
  stroke-width: 2;
}

/* Styles pour le popup de confirmation */
.delete-confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.delete-confirm-dialog {
  background-color: #1f2937;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.delete-confirm-header {
  padding: 1rem;
  background-color: rgba(239, 68, 68, 0.1);
  border-bottom: 1px solid rgba(239, 68, 68, 0.2);
}

.delete-confirm-header h3 {
  margin: 0;
  color: #f87171;
  font-size: 1.25rem;
  font-weight: 600;
}

.delete-confirm-body {
  padding: 1.5rem;
  color: #e5e7eb;
  line-height: 1.5;
}

.delete-confirm-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0.05);
  gap: 0.75rem;
}

.cancel-button {
  padding: 0.5rem 1rem;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.375rem;
  color: #e5e7eb;
  font-weight: 500;
  transition: all 0.2s ease;
}

.cancel-button:hover {
  background-color: rgba(255, 255, 255, 0.15);
}

.confirm-button {
  padding: 0.5rem 1rem;
  background-color: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 0.375rem;
  color: #ef4444;
  font-weight: 500;
  transition: all 0.2s ease;
}

.confirm-button:hover {
  background-color: rgba(239, 68, 68, 0.3);
  border-color: #ef4444;
}

.add-sub-element-button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.75rem;
  margin-top: 1rem;
  background-color: rgba(59, 130, 246, 0.2);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 0.375rem;
  color: #3b82f6;
  font-weight: 500;
  transition: all 0.2s ease;
}

.add-sub-element-button:hover {
  background-color: rgba(59, 130, 246, 0.3);
  border-color: #3b82f6;
}

.add-sub-element-button:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.4);
}

/* Styles pour le popup d'ajout de sous-élément */
.add-sub-element-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.add-sub-element-dialog {
  width: 600px;
  background-color: #1f2937;
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.add-sub-element-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: rgba(59, 130, 246, 0.1);
  border-bottom: 1px solid rgba(59, 130, 246, 0.2);
}

.add-sub-element-header h3 {
  margin: 0;
  color: #3b82f6;
  font-size: 1.25rem;
  font-weight: 600;
}

.add-sub-element-body {
  padding: 1.5rem;
}

.sub-elements-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
}

.sub-element-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.375rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.sub-element-item:hover {
  background-color: rgba(59, 130, 246, 0.1);
  border-color: #3b82f6;
}

.sub-element-icon {
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(59, 130, 246, 0.1);
  border-radius: 0.25rem;
  margin-bottom: 0.5rem;
  color: #3b82f6;
}

.sub-element-icon > img {
  filter: invert(1);
  width: 25px;
  height: 25px;
}

.sub-element-name {
  font-size: 0.875rem;
  color: #e5e7eb;
  text-align: center;
  word-break: break-word;
}
</style> 